import Echo from 'laravel-echo';
import socketio from "socket.io-client";
import { getAccessToken } from "context/OAuth/authService";

const echo = new Echo({
    broadcaster: 'socket.io',
    host: process.env.REACT_APP_SOCKET_URL,
    client: socketio,
    auth: {
        headers: {
            'Authorization': `Bearer ${getAccessToken() || ''}`,
            'Content-Type': 'application/json'
        }
    },
    transports: ['websocket', 'polling'],
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
});

// Add method to update auth token
echo.updateToken = (token) => {
    if (echo.connector?.socket) {
        echo.connector.socket.io.opts.extraHeaders = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }
    echo.options.auth.headers['Authorization'] = `Bearer ${token}`;
};

export default echo;